export default {
  PUSH_FTOS: 'PUSH_FTOS',
  REPLACE_FTO: 'REPLACE_FTO',
  RESET_FTOS_STATE: 'RESET_FTOS_STATE',
  SET_FTOS_IS_LOADING: 'SET_FTOS_IS_LOADING',
  SET_MY_TASK_RESPONSES: 'SET_MY_TASK_RESPONSES',
};
